// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { loadingToggler } from 'redux/modules/loading'
import { postFlipPathFrequencies } from 'helpers/api'
import { updateMultiplePathsInProjectSummary } from 'redux/modules/projectSummary'
import { updateAnalysisResults } from 'redux/modules/interferenceAnalysis'
import { errorErrorsList } from 'redux/modules/notifications'

import {
  success,
  warning,
} from 'react-notification-system-redux'

// NOTE this does not catch its own error. It is thrown to the parent
// caller and the rest of the AFS grid save process will be stopped.

const handleFrequencyFlip = () => async (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const pathIds = getState().interferenceAnalysis.get('highlightedPathIds')

      try {
        if (pathIds.size === 0) {
          return dispatch(warning({
            autoDismiss: 3,
            message: 'Must first select path(s) to flip.',
          }))
        }

        const { entity } = await postFlipPathFrequencies({ pathIds })

        // we gotta update the project summary redux state because the
        // stored paths' frequency counts are not necessarily right
        // and
        // we gotta update the analysis grid results because HI/LO will
        // likely change for flipping and the AFS Grid results (colors and stuffs)
        // will definitely need to be recalculated if some polarization toggling has happened
        await Promise.all([
          dispatch(updateMultiplePathsInProjectSummary(pathIds)),
          dispatch(updateAnalysisResults()),
        ])

        dispatch(success({
          autoDismiss: 5,
          message: (
            <span id={'afs-grid-frequency-flip-success'}>
              {entity}
            </span>),
        }))
      } catch (err) {
        console.warn(err)
        dispatch(errorErrorsList(err))
      }
    })
  )
)

export default handleFrequencyFlip
